import React from "react";
import { Box, Button, ThemeProvider, createTheme } from "@mui/material";
import Title from "./details/Title";
import Main from "./details/Main";
import { CustomerBuyerOffersState, Offer } from "../../../shared/models/customerMyOffersModel";
import { useAppDispatch, useAppSelector } from "../../../../shared/hooks/sharedHooks";
import Additional from "./details/Additional";
import { getDocument, selectOffer } from "../../../offersReceived/customerReceivedOffersSilce";
import { Rfq, RfqStatusCode } from "../../models/models";
import { Page } from "../../../../shared/models/models";

interface MyOffersDetailsProps {
  rfqStatusCode?: RfqStatusCode;
  rfqs?: Page<Rfq>;
}

const MyOffersDetails = ({ rfqStatusCode, rfqs }: MyOffersDetailsProps) => {
  const { query, offers, offer, loading, success, error } = useAppSelector<CustomerBuyerOffersState>(
    (state: any) => state.customerReceivedOffers
  );

  const dispatch = useAppDispatch();

  const handleClose = () => {
    dispatch(selectOffer(null));
  };

  const handleDownloadDocument = async (event: any, item: Offer) => {
    event.stopPropagation();
    const result = await dispatch(getDocument(item.id));
    if (result?.payload) {
      download(result.payload);
    }
  };

  const download = (file: any) => {
    const downloadURL = URL.createObjectURL(file.data);
    const link = document.createElement("a");
    const fileName = file.headers.get('content-disposition').split("''").pop();
    link.href = downloadURL;
    link.target = "_blank";
    link.download = `${fileName}.pdf`;
    link.click();
    link.remove();
  };

  const theme = createTheme({
    components: {}
  });

  return (
    <ThemeProvider theme={theme}>
      {offer && <Box
        className="flex flex-col justify-between h-full"
        sx={{ width: 375, background: "#FFF", color: "#333", padding: "16px 16px 0 16px" }}
      >
        <Box>
          <Title name={offer?.supplier.name} onClose={handleClose} />

          <Main offer={offer} className="mt-4" />
        </Box>

        <Box>
          <Additional offer={offer} className="mt-4" />

          <Box className="mt-4 mb-4">
            {offer?.documentFile && (
              <Button variant="outlined" className="w-full" onClick={(event) => handleDownloadDocument(event, offer)}>
                DOWNLOAD OFFER IN .PDF
              </Button>
            )}

            {rfqStatusCode === RfqStatusCode.open && (
              <Box className="mt-2">
                <Button variant="contained" className="w-full">
                  SEND TO CART
                </Button>
              </Box>
            )}
          </Box>
        </Box>
      </Box>}
    </ThemeProvider>
  );
};
export default MyOffersDetails;
